import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    rates: [],
    selected: [],
    project: "",
    site: "",
    filterBy: "",
    listView: false,
    sortBy: "",
    filterBy: "",
    loadingRates: false,
    showDetails: false,
    // defaultHeaders: [
    //     'active',
    //     'project.name',
    //     'site.name',
    //     'spoil.name',
    //     'tip.name',
    //     'vehicleType.name',
    //     'costPrice',
    //     'sellPrice'
    // ],
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyRate', "")
      context.commit('modifyVehicleType', "")
      context.commit('modifySite', "")
      context.commit('resetTrips')
    }
  },
  getters: {
    getRates: state => state.rates
  }
}